import React, { useEffect, useState, useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import DataTables from "../../CommonDataTable/DataTable";
import config from "../../../../config/config";
import apiCalls from "../../../../config/apiCalls";
import ViewModal from "../../CommonModals/viewModal";
import NewUserModal from "../../CommonModals/NewUserModal";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import FormModal from "../../../Form/FormModal";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// config file

const Contracts = (props) => {
  const [languageData, setLanguageData] = useState();
  const [rolePermission, setRolePermission] = useState();
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [openNewUserModal, setopenNewUserModal] = useState(false);
  const [item, setItem] = useState({});
  const [newFormFields, setNewFormField] = useState([]);

  let user = localStorage.getItem('loginCredentials') ? JSON.parse(localStorage.getItem('loginCredentials')) : {};
  let dataTableRef = useRef(null);
  const params = useParams();
  const pdfRef = useRef(null);

  useEffect(() => {
    let screenPermissions = RolePermissions.screenPermissions("Contracts");
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
  }, []);

  const setData = (props) => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id);
      return rowData;
    }
  };

  const getTableFields = () => {
    let roleTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Admin",
        value: "Admin",
      },
      {
        label: "Super Admin",
        value: "Super Admin",
      },
      {
        label: "User",
        value: "User",
      },
    ];
    let StatusTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    const categoryTypes = [
      { label: "Debit Invoice", value: "Debit Invoice", color: "danger" },
      { label: "Sales Invoice", value: "Sales Invoice", color: "success" },
      { label: "Credit Invoice", value: "Credit Invoice", color: "info" },
      { label: "Proforma Invoice", value: "Proforma Invoice", color: "primary" },
      { label: "Return Invoice", value: "Return Invoice", color: "warning" },
      { label: "Others", value: "Others", color: "secondary" },
    ];

    let data = [
      {
        textAlign: "center",
        width: "5%",
        field: "Check Box",
        label: "Check Box",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: false,
        mobile: true,
        displayInSettings: true,
        displayinlist: "false",
        displayinaddForm: "false",
        displayineditForm: "false",
        globalSearchField: "false",
        isFieldRequired: "false",
        tDisplay: true,
      },
      {
        textAlign: "center",
        width: "5%",
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        displayinlist: "false",
        displayinaddForm: "false",
        displayineditForm: "false",
        globalSearchField: "false",
        isFieldRequired: "false",
        show: true,
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        show: true,
        textAlign: "center",
        width: "5%",
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "true",
        displayineditForm: "true",
        globalSearchField: "false",
        isFieldRequired: "false",
        mobile: true,
        tDisplay: true,
      },
      {
        name: "status",
        type: "dropDown",
        placeholder: "Status",
        label: "Status",
        width: "10%",
        header: "Status",
        field: "status",
        options: [
          { label: "COMPLETED", value: "COMPLETED", color: "success" },
          { label: "FAILED", value: "FAILED", color: "danger" },
          { label: "PROCESSING", value: "PROCESSING", color: "warning" },
        ],
        width: "120px",
        textAlign: "center",
        show: true,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "true",
        required: true,
        displayInSettings: true,
        fieldType: "dropDown",
        tDisplay: true,
        sortable: true,
        filter: true,
        style: {
          textTransform: 'uppercase'
        }
      },
      {
        name: "party",
        type: "text",
        placeholder: "party",
        label: "Party",
        width: '20%',
        header: "Party",
        field: "partiesInvolved.partyA.name",
        sortable: true,
        filter: true,
        show: true,
        mobile: true,
        fieldType: "subField",
        subKeys: ["requiredMainFields.partySummary", "partiesInvolved.buyer.name", "partiesInvolved.partyA.name"],
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "termSummary",
        type: "text",
        placeholder: "Term Summary",
        label: "Term Summary",
        width: '20%',
        header: "Term Summary",
        field: "requiredMainFields.termSummary",
        sortable: true,
        filter: true,
        show: true,
        mobile: true,
        fieldType: "subField",
        subKeys: ["requiredMainFields.termSummary"],
        displayInSettings: true,
        tDisplay: true,
      },
      //       {
      //   name: "category",
      //   type: "dropDown",
      //   placeholder: "Category",
      //   label: "Category",
      //   header: "Category",
      //   field: "category",
      //   options: categoryTypes,
      //   width: "120px",
      //   textAlign: "center",
      //   show: true,
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   globalSearchField: "true",
      //   required: true,
      //   displayInSettings: true,
      //   fieldType: "dropDown",
      //   tDisplay: true,
      //   sortable: true,
      //   filter: true,
      //   style: {
      //     textTransform: 'uppercase'
      //   }
      // },
      {
        name: "paymentSummary",
        type: "text",
        placeholder: "Payment Summary",
        label: "Payment Summary",
        width: '20%',
        header: "Payment",
        field: "requiredMainFields.paymentSummary",
        sortable: true,
        filter: true,
        show: true,
        mobile: true,
        fieldType: "subField",
        subKeys: ["requiredMainFields.paymentSummary"],
        displayInSettings: true,
        tDisplay: true,
        textAlign: "center",
      },
      {
        name: "returnsChargebacksSummary",
        type: "text",
        placeholder: "Returns Chargebacks Summary",
        label: "Returns Chargebacks Summary",
        width: '20%',
        header: "Returns Chargebacks",
        field: "requiredMainFields.returnsChargebacksSummary",
        sortable: true,
        filter: true,
        show: true,
        mobile: true,
        fieldType: "subField",
        subKeys: ["requiredMainFields.returnsChargebacksSummary"],
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "auditSummary",
        type: "text",
        placeholder: "Audit Summary",
        label: "Audit Summary",
        width: '20%',
        header: "Audit Summary",
        field: "requiredMainFields.auditSummary",
        sortable: true,
        filter: true,
        show: true,
        mobile: true,
        fieldType: "subField",
        subKeys: ["requiredMainFields.auditSummary"],
        displayInSettings: true,
        tDisplay: true,

      },
      {
        name: "portalFees",
        type: "text",
        placeholder: "Portal Fees",
        label: "Portal Fees",
        width: '20%',
        header: "Portal Fees",
        field: "requiredMainFields.portalFees",
        sortable: true,
        filter: true,
        show: true,
        mobile: true,
        fieldType: "subField",
        subKeys: ["requiredMainFields.portalFees"],
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "rebates",
        type: "text",
        placeholder: "Rebates",
        label: "Rebates",
        width: '20%',
        header: "Rebates",
        field: "requiredMainFields.rebates",
        sortable: true,
        filter: true,
        show: true,
        mobile: true,
        fieldType: "subField",
        subKeys: ["requiredMainFields.rebates"],
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "priceProtection",
        type: "text",
        placeholder: "Price Protection",
        label: "Price Protection",
        width: '20%',
        header: "Price Protection",
        field: "requiredMainFields.priceProtection",
        sortable: true,
        filter: true,
        show: true,
        mobile: true,
        fieldType: "subField",
        subKeys: ["requiredMainFields.priceProtection"],
        displayInSettings: true,
        tDisplay: true,
        subFieldType: "dropdown",
        options: [
          { label: "Yes", value: "Yes", color: "success" },
          { label: "No", value: "No", color: "primary" },
        ],
        textAlign: "center",

      },
      {
        name: "enterprisePayments",
        type: "text",
        placeholder: "Enterprise Payments",
        label: "Enterprise Payments",
        width: '20%',
        header: "Enterprise Payments",
        field: "requiredMainFields.enterprisePayments",
        sortable: true,
        filter: true,
        show: true,
        mobile: true,
        fieldType: "subField",
        subKeys: ["requiredMainFields.enterprisePayments"],
        displayInSettings: true,
        tDisplay: true,
        subFieldType: "dropdown",
        options: [
          { label: "Yes", value: "Yes", color: "success" },
          { label: "No", value: "No", color: "primary" },
        ],
        textAlign: "center",

      },
      {
        name: "failureToSupply",
        type: "text",
        placeholder: "Failure To Supply",
        label: "Failure To Supply",
        width: '20%',
        header: "Failure To Supply",
        field: "requiredMainFields.failureToSupply",
        sortable: true,
        filter: true,
        show: true,
        mobile: true,
        fieldType: "subField",
        subKeys: ["requiredMainFields.failureToSupply"],
        displayInSettings: true,
        tDisplay: true,
        subFieldType: "dropdown",
        options: [
          { label: "Yes", value: "Yes", color: "success" },
          { label: "No", value: "No", color: "primary" },
          { label: "-", value: "-", color: "danger" },
        ],
        textAlign: "center",

      },
      {
        name: "administrativeFees",
        type: "text",
        placeholder: "Administrative Fees",
        label: "Administrative Fees",
        width: '20%',
        header: "Administrative Fees",
        field: "requiredMainFields.administrativeFees",
        sortable: true,
        filter: true,
        show: true,
        mobile: true,
        fieldType: "subField",
        subKeys: ["requiredMainFields.administrativeFees"],
        displayInSettings: true,
        tDisplay: true,
      },

      // {
      //   name: "partyB",
      //   type: "text",
      //   placeholder: "partyB",
      //   label: "partyB",
      //   width: '20%',
      //   header: "Party B",
      //   field: "partiesInvolved.partyB.name",
      //   subField1: "partiesInvolved.supplier.name",
      //   sortable: true,
      //   filter: true,
      //   show: true,
      //   mobile: true,
      //   fieldType: "subField",
      //   displayInSettings: true,
      //   tDisplay: true,
      // },
      {
        name: "fileName",
        type: "text",
        placeholder: "File",
        label: "File",
        header: "File",
        width: "50%",
        id: "fileName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        fieldType: "redirectable",
        fileViewType: 'view',
        textAlign: "left",
        globalSearchField: "true",
        show: true,
        field: "fileName",
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
        displayIcon: true,
        fieldTypes: 'fileUpload',
        filter: true,
        redirectFilterField: 'parentFolderId',
        redirecTo: 'myDocuments',
        // iconName : 'folder',
        showIcon: true,
      },


      // {
      //   name: "invoiceDate",
      //   type: "date",
      //   placeholder: "Invoice Date",
      //   label: "Invoice Date",
      //   width: 120,
      //   header: "Invoice Date",
      //   field: "invoiceDate",
      //   sortable: true,
      //   filter: true,
      //   show: true,
      //   mobile: true,
      //   displayInSettings: true,
      //   tDisplay: true,
      // },
      // {
      //   name: "billerName",
      //   type: "text",
      //   placeholder: "Biller Name",
      //   label: "Biller Name",
      //   width: 200,
      //   header: "Biller Name",
      //   field: "billerName",
      //   sortable: true,
      //   filter: true,
      //   show: true,
      //   mobile: true,
      //   displayInSettings: true,
      //   tDisplay: true,

      // },
      // {
      //   name: "buyerName",
      //   type: "text",
      //   placeholder: "Buyer Name",
      //   label: "Buyer Name",
      //   width: 200,
      //   header: "Buyer Name",
      //   field: "buyerName",
      //   sortable: true,
      //   filter: true,
      //   show: true,
      //   mobile: true,
      //   displayInSettings: true,
      //   tDisplay: true,
      // },
      // {
      //   name: "category",
      //   type: "dropDown",
      //   placeholder: "Category",
      //   label: "Category",
      //   header: "Category",
      //   field: "category",
      //   options: categoryTypes,
      //   width: "120px",
      // textAlign: "center",
      //   show: true,
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   globalSearchField: "true",
      //   required: true,
      //   displayInSettings: true,
      //   fieldType: "dropDown",
      //   tDisplay: true,
      //   sortable: true,
      //   filter: true,
      //   style: {
      //     textTransform: 'uppercase'
      //   }
      // },
      // {
      //   name: "currency",
      //   type: "text",
      //   placeholder: "Currency",
      //   label: "Currency",
      //   width: 80,
      //   header: "Currency",
      //   field: "currency",
      //   fieldType: "text",
      //   sortable: true,
      //   filter: true,
      //   show: true,
      //   mobile: true,
      //   displayInSettings: true,
      //   tDisplay: true,
      //   textAlign: "center",
      //   style: {
      //     fontWeight: 700,
      //     color: "#12225f"
      //   }
      // },
      // {
      //   name: "subtotal",
      //   type: "text",
      //   placeholder: "Subtotal",
      //   label: "Subtotal",
      //   width: 100,
      //   header: "Subtotal",
      //   field: "subtotal",
      //   sortable: true,
      //   filter: true,
      //   textAlign: "Right",
      //   show: true,
      //   mobile: true,
      //   displayInSettings: true,
      //   tDisplay: true,
      // },
      // {
      //   name: "taxAmount",
      //   type: "text",
      //   placeholder: "Tax Amount",
      //   label: "Tax Amount",
      //   width: 100,
      //   header: "Tax Amount",
      //   field: "taxAmount",
      //   sortable: true,
      //   filter: true,
      //   textAlign: "Right",
      //   show: true,
      //   mobile: true,
      //   displayInSettings: true,
      //   tDisplay: true,
      // },
      // {
      //   name: "otherCharges",
      //   type: "text",
      //   placeholder: "Other Charges",
      //   label: "Other Charges",
      //   width: 100,
      //   header: "Other Charges",
      //   field: "otherCharges",
      //   sortable: true,
      //   filter: true,
      //   textAlign: "Right",
      //   show: true,
      //   mobile: true,
      //   displayInSettings: true,
      //   tDisplay: true,
      // },
      // {
      //   name: "totalAmount",
      //   type: "text",
      //   placeholder: "Total Amount",
      //   label: "Total Amount",
      //   width: 120,
      //   header: "Total Amount",
      //   field: "totalAmount",
      //   sortable: true,
      //   filter: true,
      //   textAlign: "Right",
      //   show: true,
      //   mobile: true,
      //   displayInSettings: true,
      //   tDisplay: true,
      // },

      // {
      //   name: "complianceScore",
      //   type: "text",
      //   placeholder: "Compliance Score",
      //   label: "Compliance Score",
      //   header: "Compliance Score",
      //   field: "complianceScore",
      //   options: [],
      //   width: "120px",
      //   textAlign: "center",
      //   show: true,
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   globalSearchField: "true",
      //   required: true,
      //   displayInSettings: true,
      //   fieldType: "text",
      //   tDisplay: true,
      //   sortable: true,
      //   filter: true,
      //   style: {
      //     textTransform: 'uppercase',
      //     fontWeight: 700,
      //     color: "#102256"
      //   }
      // },
      // {
      //   name: "reviewNeeded",
      //   type: "dropDown",
      //   placeholder: "Review Needed",
      //   label: "Review Needed",
      //   header: "Review Needed",
      //   field: "reviewNeeded",
      //   options: [
      //     { label: "false", value: "false", color: "success" },
      //     { label: "true", value: "true", color: "primary" },
      //   ],
      //   width: "120px",
      //   textAlign: "center",
      //   show: true,
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   globalSearchField: "true",
      //   required: true,
      //   displayInSettings: true,
      //   fieldType: "dropDown",
      //   tDisplay: true,
      //   sortable: true,
      //   filter: true,
      //   style: {
      //     textTransform: 'uppercase'
      //   }
      // },

      {
        name: "createdByName",
        type: "text",
        placeholder: "Created By",
        label: "Created By",
        width: 120,
        header: "Created By",
        field: "createdByName",
        sortable: true,
        filter: true,
        show: false,
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },


    ];

    return data;
  };


  const getFormFields = () => {
    let statusTypes = [
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    return [
      {
        name: "name",
        fieldName: "name",
        type: "text",
        placeholder: "Name",
        value: "",
        label: "Name",
        width: "120px",
        addFormOrder: 1,
        editFormOrder: 1,
        stringType: null,
        derivedValue: "name=undefined",
        capitalizeTableText: false,
        sortable: true,
        filter: true,
        id: "name",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinregisterForm: false,
        displayinlist: "true",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: "",
        globalSearchField: "true",
        controllerId: null,
        isClickable: "",
        isAddToIndex: false,
        isBulkUploadField: true,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
        },
        isAddFormHidden: false,
        isEditFormHidden: false,
        capitalizeValue: true
      },
    ];
  };

  const submit = async (item) => {
    setIsOpenFormModal(true);
    // await this.formModalRef.getRowData(item, 'edit');
    console.log("Submit Button in sode          ");
  };

  const closeFormModal = async () => {
    setIsOpenFormModal(false);
  };

  const cancelReset = async (type) => {
    setopenNewUserModal(false);
    // window.location.reload();
    if (dataTableRef.current) {
      const { getDataFromServer, filterCriteria } = await dataTableRef.current;
      getDataFromServer(filterCriteria);
    }
  };
  const downloadPdf = async (data) => {
    if (!pdfRef.current) return;

    // 1️⃣ Capture the DOM as canvas
    const canvas = await html2canvas(pdfRef.current, {
      scale: 1.5,
      useCORS: true,
      backgroundColor: "#ffffff",
      scrollY: -window.scrollY,
    });

    // 2️⃣ Create PDF
    const pdf = new jsPDF("p", "mm", "a4");

    // 3️⃣ Standard margins (industry safe)
    const marginTop = 12;
    const marginBottom = 12;
    const marginSide = 12;

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const usableWidth = pageWidth - marginSide * 2;
    const usableHeight = pageHeight - marginTop - marginBottom;

    // 4️⃣ Scale ratio between canvas and PDF
    const scale = usableWidth / canvas.width;

    // 5️⃣ Height of one PDF page in canvas pixels
    const pageCanvasHeight = usableHeight / scale;

    let yOffset = 0;
    let pageIndex = 0;

    // 6️⃣ Slice canvas page by page WITHOUT skipping pixels
    while (yOffset < canvas.height) {
      const pageCanvas = document.createElement("canvas");
      pageCanvas.width = canvas.width;
      pageCanvas.height = Math.min(
        pageCanvasHeight,
        canvas.height - yOffset
      );

      const ctx = pageCanvas.getContext("2d");

      ctx.drawImage(
        canvas,
        0,
        yOffset,
        canvas.width,
        pageCanvas.height,
        0,
        0,
        canvas.width,
        pageCanvas.height
      );

      const imgData = pageCanvas.toDataURL("image/jpeg", 0.95);

      if (pageIndex > 0) pdf.addPage();

      pdf.addImage(
        imgData,
        "JPEG",
        marginSide,
        marginTop,
        usableWidth,
        pageCanvas.height * scale,
        undefined,
        "FAST"
      );

      yOffset += pageCanvasHeight;
      pageIndex++;
    }

    // 7️⃣ Save PDF
    pdf.save(
      `${data?.fileName?.replace(/\.[^/.]+$/, "") || "agreement"}.pdf`
    );
  };



  const saveDataToServer = async (item, field, value) => {
    let userBody;
    if (item?.length > 0 && field && value) {
      let selectedIds = item.map((row) => row._id);
      userBody = {
        selectedIds: selectedIds,
        updatedDetails: { [field]: value },
      };
    } else {
      return;
    }
    if (userBody) {
      let method, apiUrl;
      method = "POST";
      apiUrl = `${apiCalls.agreement}/multiUpdate`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, "success");
          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, "error");
          }
        })
        .catch((err) => {
          return err;
        });
    } else {
      return;
    }
  };

  const isEditPermission = rolePermission?.type == "Edit" ? true : false;
  const actionTypes = [
    {
      name: "Delete",
      options: [
        {
          label: "Delete",
          value: "Delete",
          show: rolePermission?.actions?.includes("Delete") ? true : false,
          multiple: true,
        },
      ],
    },
  ];
  // const rowExpansionTemplate = (rowData) => {
  //   return (
  //     <div className="expansion-content">
  //       <AudioPlayer rowData={rowData} />
  //     </div>
  //   );
  // };

  const files = [
    "agreement.zip"
  ];

  const sampleFiles = files.map(fileName => ({
    filePath: `${config.imgUrl}server/upload/aiPocSampleFiles/${fileName}`,
    fileName
  }));


  const agreementViewModalTemplate = (data) => {
    if (!data) return null;
    const newData = { ...data };


    const partyA = newData?.partiesInvolved?.partyA?.name || newData?.partiesInvolved?.buyer.name || "-";

    const partySummary =
      partyA
    newData.requiredMainFields = {
      partySummary,
      ...newData.requiredMainFields
    };


    const formatDate = (value) => {
      if (!value) return "N/A";
      try {
        if (value?.$date) return new Date(value.$date).toLocaleDateString();
        if (typeof value === "object" && (value.date || value.dateText)) {
          if (value.date) return new Date(value.date).toLocaleDateString();
          return value.dateText;
        }
        return new Date(value).toLocaleDateString();
      } catch (e) {
        return typeof value === "string" ? value : JSON.stringify(value);
      }
    };

    // Helper function to split keys into columns based on count
    const splitKeysIntoColumns = (keys) => {
      if (keys.length <= 3) return [keys]; // Single column if 3 or fewer

      const midPoint = Math.ceil(keys.length / 2);
      const leftCol = keys.slice(0, midPoint);
      const rightCol = keys.slice(midPoint);

      return [leftCol, rightCol];
    };

    // Enhanced renderNestedObject with column layout support
    const renderNestedObject = (obj, level = 0, forceSingleColumn = false) => {
      if (!obj || typeof obj !== "object") {
        return (
          <span className="text-dark" style={{ fontSize: "12px" }}>
            {obj === 0 ? 0 : obj || "N/A"}
          </span>
        );
      }

      if (Array.isArray(obj)) {
        return (
          <ul className={`list-unstyled mb-0 ${level > 0 ? "ms-2" : ""}`} style={{ fontSize: "12px" }}>
            {obj.map((item, idx) => (
              <li key={idx} className="mb-1">
                {typeof item === "object" && item !== null
                  ? renderNestedObject(item, level + 1)
                  : item ?? "N/A"}
              </li>
            ))}
          </ul>
        );
      }

      const entries = Object.entries(obj);
      const keys = Object.keys(obj);
      const shouldUseColumns = !forceSingleColumn && keys.length > 3 && level === 0;
      const columnGroups = shouldUseColumns ? splitKeysIntoColumns(keys) : [keys];

      return (
        <div className={`${level > 0 ? "ms-2" : ""}`}>
          {shouldUseColumns ? (
            <div className="row">
              {columnGroups.map((colKeys, colIndex) => (
                <div key={colIndex} className="col-md-6">
                  {colKeys.map((key) => {
                    const value = obj[key];
                    return (
                      <div key={key} className="mb-1">
                        <small
                          className=" d-block text-capitalize"
                          style={{ fontSize: "0.8rem", fontWeight: "bold" }}
                        >
                          {key
                            .replace(/([A-Z])/g, " $1")
                            .replace(/^./, (str) => str.toUpperCase())}
                          :
                        </small>
                        {key.toLowerCase().includes("date") ? (
                          <span className="text-dark" style={{ fontSize: "12px" }}>
                            {formatDate(value)}
                          </span>
                        ) : typeof value === "object" && value !== null ? (
                          renderNestedObject(value, level + 1)
                        ) : (
                          <span className="text-dark" style={{ fontSize: "12px" }}>
                            {value === 0 ? 0 : value || "N/A"}
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          ) : (
            entries.map(([key, value]) => (
              <div key={key} className="mb-1">
                <small
                  className="text-muted d-block text-capitalize"
                  style={{ fontSize: "0.8rem", fontWeight: "normal" }}
                >
                  {key
                    .replace(/([A-Z])/g, " $1")
                    .replace(/^./, (str) => str.toUpperCase())}
                  :
                </small>
                {key.toLowerCase().includes("date") ? (
                  <span style={{ fontSize: "0.875rem", fontWeight: "normal" }}>
                    {formatDate(value)}
                  </span>
                ) : typeof value === "object" && value !== null ? (
                  renderNestedObject(value, level + 1)
                ) : (
                  <span style={{ fontSize: "0.875rem", fontWeight: "normal" }}>
                    {value === 0 ? 0 : value || "N/A"}
                  </span>
                )}
              </div>
            ))
          )}
        </div>
      );
    };

    // Helper function to check if section has sub-cards structure
    const hasSubCards = (sectionData) => {
      if (!sectionData || typeof sectionData !== "object") return false;
      const keys = Object.keys(sectionData);
      return keys.some(
        (key) =>
          typeof sectionData[key] === "object" &&
          sectionData[key] !== null &&
          !Array.isArray(sectionData[key])
      );
    };

    // Helper function to render sub-cards with column layout
    const renderSubCards = (sectionData, sectionKey) => {
      if (!sectionData || typeof sectionData !== "object") return null;

      // Special handling: partiesInvolved
      if (sectionKey === "partiesInvolved") {
        return (
          <div className="row">
            {sectionData.buyer && (
              <div className="col-md-6 mb-2">
                <div className="card h-100 border p-2">
                  <h6
                    className="mb-2"
                    style={{
                      color: "black",
                      fontSize: "0.9rem",
                      fontWeight: "600", // semi-bold
                      paddingBottom: "0.25rem",
                      borderBottom: "1px solid #e9ecef",
                    }}
                  >
                    Buyer Information
                  </h6>
                  <div style={{ fontSize: "0.875rem", fontWeight: "normal" }}>
                    {renderNestedObject(sectionData.buyer)}
                  </div>
                </div>
              </div>
            )}

            {sectionData.supplier && (
              <div className="col-md-6 mb-2">
                <div className="card h-100 border p-2">
                  <h6
                    className="mb-2"
                    style={{
                      color: "black",
                      fontSize: "0.9rem",
                      fontWeight: "600", // semi-bold
                      paddingBottom: "0.25rem",
                      borderBottom: "1px solid #e9ecef",
                    }}
                  >
                    Supplier Information
                  </h6>
                  <div style={{ fontSize: "0.875rem", fontWeight: "normal" }}>
                    {renderNestedObject(sectionData.supplier)}
                  </div>
                </div>
              </div>
            )}
            {sectionData.partyA && (
              <div className="col-md-6 mb-2">
                <div className="card h-100 border p-2">
                  <h6
                    className="mb-2"
                    style={{
                      color: "#12225f",
                      fontSize: "0.9rem",
                      fontWeight: "600", // semi-bold
                      paddingBottom: "0.25rem",
                      borderBottom: "1px solid #e9ecef",
                    }}
                  >
                    {sectionData.partyA.name}
                  </h6>
                  <div style={{ fontSize: "0.875rem", fontWeight: "normal" }}>
                    {renderNestedObject(sectionData.partyA)}
                  </div>
                </div>
              </div>
            )}

            {sectionData.partyB && (
              <div className="col-md-6 mb-2">
                <div className="card h-100 border p-2">
                  <h6
                    className="mb-2"
                    style={{
                      color: "#12225f",
                      fontSize: "0.9rem",
                      fontWeight: "600", // semi-bold
                      paddingBottom: "0.25rem",
                      borderBottom: "1px solid #e9ecef",
                    }}
                  >
                    {sectionData.partyB.name}

                    Supplier Information
                  </h6>
                  <div style={{ fontSize: "0.875rem", fontWeight: "normal" }}>
                    {renderNestedObject(sectionData.partyB)}
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      }

      // Special handling: deliverablesScopeOfWork
      if (sectionKey === "deliverablesScopeOfWork") {
        const buyerOb =
          sectionData?.buyerObligations ??
          sectionData?.responsibilities?.buyerObligations;
        const supplierOb =
          sectionData?.supplierObligations ??
          sectionData?.responsibilities?.supplierObligations;

        if (!buyerOb && !supplierOb) return renderNestedObject(sectionData);

        return (
          <div className="row">
            {supplierOb && (
              <div className="col-md-6 mb-2">
                <div className="card h-100 border p-2">
                  <h6
                    className="mb-2"
                    style={{
                      color: "black",
                      fontSize: "0.9rem",
                      fontWeight: "600", // semi-bold
                      paddingBottom: "0.25rem",
                      borderBottom: "1px solid #e9ecef",
                    }}
                  >
                    Supplier Obligations
                  </h6>
                  <div style={{ fontSize: "0.875rem", fontWeight: "normal" }}>
                    {renderNestedObject(supplierOb)}
                  </div>
                </div>
              </div>
            )}

            {buyerOb && (
              <div className="col-md-6 mb-2">
                <div className="card h-100 border p-2">
                  <h6
                    className="mb-2"
                    style={{
                      color: "black",
                      fontSize: "0.9rem",
                      fontWeight: "600", // semi-bold
                      paddingBottom: "0.25rem",
                      borderBottom: "1px solid #e9ecef",
                    }}
                  >
                    Buyer Obligations
                  </h6>
                  <div style={{ fontSize: "0.875rem", fontWeight: "normal" }}>
                    {renderNestedObject(buyerOb)}
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      }

      // Generic handling for other sections with sub-cards
      const entries = Object.entries(sectionData);
      const subCardEntries = entries.filter(
        ([_, value]) => typeof value === "object" && value !== null && !Array.isArray(value)
      );

      if (subCardEntries.length > 0) {
        return (
          <div className="row">
            {subCardEntries.map(([key, value]) => (
              <div
                key={key}
                className={`col-md-${12 / Math.min(subCardEntries.length, 2)} mb-2`}
              >
                <div className="card h-100 border p-2">
                  <h6
                    className="mb-2"
                    style={{
                      color: "black",
                      fontSize: "0.9rem",
                      fontWeight: "600", // semi-bold
                      paddingBottom: "0.25rem",
                      borderBottom: "1px solid #e9ecef",
                    }}
                  >
                    {key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}
                  </h6>
                  <div style={{ fontSize: "0.875rem", fontWeight: "normal" }}>
                    {renderNestedObject(value)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        );
      }

      return renderNestedObject(sectionData);
    };
    const toExhibitsArray = (exhibitsData) => {
      if (Array.isArray(exhibitsData)) return exhibitsData;
      if (Array.isArray(exhibitsData?.list)) return exhibitsData.list;
      return [];
    };

    // Special renderer for Exhibits / Schedules
    const renderExhibitsSchedules = (exhibitsData) => {
      const exhibitsArray = toExhibitsArray(exhibitsData);

      if (exhibitsArray.length === 0) {
        return (
          <span style={{ fontSize: "11px", fontWeight: "normal" }}>
            No exhibits or schedules available
          </span>
        );
      }

      return (
        <div className="row">
          {exhibitsArray.map((exhibit, index) => {
            const summaryLines = Array.isArray(exhibit?.wholeSummary)
              ? exhibit.wholeSummary
              : typeof exhibit?.wholeSummary === "string"
                ? exhibit.wholeSummary.split(/\n+/).filter(Boolean)
                : [];

            return (
              <div key={exhibit?.label ?? index} className="col-md-6 col-lg-4 mb-2">
                <div className="card h-100 border p-2">

                  {/* Exhibit Label */}
                  <div
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "#000",
                      marginBottom: "2px",
                    }}
                  >
                    {exhibit?.label || `Exhibit ${index + 1}`}
                  </div>

                  {/* Name / Description */}
                  {exhibit?.nameOrDescription && (
                    <div
                      style={{
                        fontSize: "11px",
                        fontWeight: 500,
                        color: "#333",
                        marginBottom: "4px",
                      }}
                    >
                      {exhibit.nameOrDescription}
                    </div>
                  )}

                  {/* Variable-Labeled Summary */}
                  {summaryLines.length > 0 && (
                    <div style={{ fontSize: "11px", color: "#555" }}>
                      {summaryLines.map((line, i) => {
                        const colonIndex = line.indexOf(":");
                        const hasLabel = colonIndex > 0;

                        const label = hasLabel
                          ? line.slice(0, colonIndex).trim()
                          : null;

                        const value = hasLabel
                          ? line.slice(colonIndex + 1).trim()
                          : line;

                        return (
                          <div key={i} style={{ marginBottom: "3px" }}>
                            {label ? (
                              <>
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "12px",
                                    color: "#000",
                                  }}
                                >
                                  {label}:
                                </span>{" "}
                                <span>{value}</span>
                              </>
                            ) : (
                              <span>{value}</span>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      );
    };

    // Updated sections to match your new extraction schema
    const SECTION_KEYS = [
      "requiredMainFields",
      "keyContractTerms",
      "partiesInvolved",
      "exhibitsSchedules",
      "effectiveDate",
      "contractDuration",
      "terminationConditions",
      "paymentTerms",
      "pricingTerms",
      "fees",
      "deliverablesScopeOfWork",
      "confidentialityObligations",
      "complianceRegulatory",
      "liabilityIndemnityTerms",
      "warrantyDisclaimers",
      "returnsRefundsExchanges",
      "chargebacksRebates",
      "shippingDeliveryRisk",
      "auditInspectionRights",
      "insuranceRequirements",
      "assignmentChangeOfControl",
      "notices",
      "governingLawJurisdiction",
      "disputeResolution",
    ];

    const SECTION_LABELS = {
      requiredMainFields: "Required Main Fields",
      keyContractTerms: "Key Contract Terms",
      partiesInvolved: "Parties Involved",
      effectiveDate: "Effective Date",
      contractDuration: "Contract Duration",
      terminationConditions: "Termination Conditions",
      paymentTerms: "Payment Terms",
      pricingTerms: "Pricing Terms",
      fees: "Fees",
      deliverablesScopeOfWork: "Deliverables & Scope of Work",
      confidentialityObligations: "Confidentiality Obligations",
      complianceRegulatory: "Compliance / Regulatory",
      liabilityIndemnityTerms: "Liability & Indemnity Terms",
      warrantyDisclaimers: "Warranties & Disclaimers",
      returnsRefundsExchanges: "Returns / Refunds / Exchanges",
      chargebacksRebates: "Chargebacks / Rebates",
      shippingDeliveryRisk: "Shipping / Delivery / Risk",
      auditInspectionRights: "Audit / Inspection Rights",
      insuranceRequirements: "Insurance Requirements",
      assignmentChangeOfControl: "Assignment / Change of Control",
      notices: "Notices",
      governingLawJurisdiction: "Governing Law / Jurisdiction",
      disputeResolution: "Dispute Resolution",
      exhibitsSchedules: "Exhibits / Schedules",
    };

    // Signatories renderer
    const renderSignatories = (signatories) => {
      if (!signatories) return <p className="text-muted mb-0" style={{ fontWeight: "normal" }}>No signatory information available</p>;

      // New shape
      if (Array.isArray(signatories?.parties) && signatories.parties.length) {
        return (
          <div className="row">
            {signatories.parties.map((p, idx) => (
              <div key={idx} className="col-md-6 mb-2">
                <div className="card h-100 border p-2">
                  <div
                    className="d-block mb-2"
                    style={{ fontSize: "0.9rem", color: "#12225f", fontWeight: "600" }}
                  >
                    {p.partyName || "Party"}
                  </div>

                  {Array.isArray(p.signers) && p.signers.length ? (
                    p.signers.map((s, sIdx) => (
                      <div key={sIdx} className="mb-2">
                        <div className="mb-1">
                          <small className="text-muted d-block" style={{ fontSize: "0.8rem", fontWeight: "normal" }}>
                            Name
                          </small>
                          <span style={{ fontWeight: "normal" }}>{s.name || "N/A"}</span>
                        </div>
                        <div className="mb-1">
                          <small className="text-muted d-block" style={{ fontSize: "0.8rem", fontWeight: "normal" }}>
                            Title
                          </small>
                          <span style={{ fontWeight: "normal" }}>{s.title || "N/A"}</span>
                        </div>
                        <div className="mb-1">
                          <small className="text-muted d-block" style={{ fontSize: "0.8rem", fontWeight: "normal" }}>
                            Date Signed
                          </small>
                          <span style={{ fontWeight: "normal" }}>{formatDate(s.date)}</span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-muted mb-0" style={{ fontWeight: "normal" }}>No signers listed</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        );
      }

      // Old shape fallback
      const hasSupplier = !!signatories?.supplier;
      const hasBuyer = !!signatories?.buyer;

      if (!hasSupplier && !hasBuyer) {
        return <p className="text-muted mb-0" style={{ fontWeight: "normal" }}>No signatory information available</p>;
      }

      return (
        <div className="row">
          {hasSupplier && (
            <div className="col-md-6 mb-2">
              <div className="card h-100 border p-2">
                <div
                  className="d-block mb-2"
                  style={{ fontSize: "0.9rem", color: "#12225f", fontWeight: "600" }}
                >
                  Supplier Signature
                </div>
                <div className="mb-1">
                  <small className="text-muted d-block" style={{ fontSize: "0.8rem", fontWeight: "normal" }}>Name</small>
                  <span style={{ fontWeight: "normal" }}>{signatories.supplier.name || "N/A"}</span>
                </div>
                <div className="mb-1">
                  <small className="text-muted d-block" style={{ fontSize: "0.8rem", fontWeight: "normal" }}>Title</small>
                  <span style={{ fontWeight: "normal" }}>{signatories.supplier.title || "N/A"}</span>
                </div>
                <div className="mb-1">
                  <small className="text-muted d-block" style={{ fontSize: "0.8rem", fontWeight: "normal" }}>Date Signed</small>
                  <span style={{ fontWeight: "normal" }}>{formatDate(signatories.supplier.date)}</span>
                </div>
              </div>
            </div>
          )}

          {hasBuyer && (
            <div className="col-md-6 mb-2">
              <div className="card h-100 border p-2">
                <div
                  className="d-block mb-2"
                  style={{ fontSize: "0.9rem", color: "#12225f", fontWeight: "600" }}
                >
                  Buyer Signature
                </div>
                <div className="mb-1">
                  <small className="text-muted d-block" style={{ fontSize: "0.8rem", fontWeight: "normal" }}>Name</small>
                  <span style={{ fontWeight: "normal" }}>{signatories.buyer.name || "N/A"}</span>
                </div>
                <div className="mb-1">
                  <small className="text-muted d-block" style={{ fontSize: "0.8rem", fontWeight: "normal" }}>Title</small>
                  <span style={{ fontWeight: "normal" }}>{signatories.buyer.title || "N/A"}</span>
                </div>
                <div className="mb-1">
                  <small className="text-muted d-block" style={{ fontSize: "0.8rem", fontWeight: "normal" }}>Date Signed</small>
                  <span style={{ fontWeight: "normal" }}>{formatDate(signatories.buyer.date)}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    };

    return (
      <>

        <div
          ref={pdfRef}
          style={{
            color: "black",
            fontSize: "14px",
            backgroundColor: "#f0f0f0",
            margin: "0 auto",
            boxSizing: "border-box",

          }}
        >
          {/* Header Section */}
          {/* <div className="card border-0 shadow-sm mb-3 p-2" style={{ backgroundColor: "white" }}>
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2
                  style={{
                    color: "#12225f",
                    fontSize: "1.2rem",
                    fontWeight: "600", // semi-bold
                    margin: "0",
                  }}
                >
                  {newData?.fileName?.replace(/\.[^/.]+$/, "")}
                </h2>

                <div className="row">

                  <div className="col-md-6 col-lg-4 mb-1">
                    <small className="text-muted d-block" style={{ fontSize: "0.8rem", fontWeight: "normal" }}>
                      Document Type
                    </small>
                    <span className="text-uppercase" style={{ fontWeight: "normal" }}>{newData?.type}</span>
                  </div>

                  <div className="col-md-6 col-lg-4 mb-1">
                    <small className="text-muted d-block" style={{ fontSize: "0.8rem", fontWeight: "normal" }}>
                      Processing Status
                    </small>
                    <span className={newData?.status === "COMPLETED" ? "text-success" : "text-warning"} style={{ fontWeight: "bold" }}>
                      {newData?.status}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* Dynamic Sections */}
          <div className="d-flex flex-column gap-3 mb-2">
            {SECTION_KEYS.map((sectionKey) => {
              const sectionData = newData?.[sectionKey];
              if (!sectionData) return null;

              return (
                <div
                  key={sectionKey}
                  className="card border-0 shadow-sm"
                  style={{
                    backgroundColor: "white",
                    padding: "15px",
                    marginTop: "5px",
                    breakInside: "avoid",
                    pageBreakInside: "avoid",
                  }}
                >
                  <div
                    style={{
                      breakInside: "avoid",
                      pageBreakInside: "avoid",
                    }}
                  >
                    <h6
                      className="mb-2"
                      style={{
                        color: "#12225f",
                        fontSize: "1.1rem",
                        fontWeight: "700",
                        margin: "0",
                        paddingBottom: "0.5rem",
                        borderBottom: "1px solid #e9ecef",
                      }}
                    >
                      {SECTION_LABELS[sectionKey] ??
                        sectionKey.replace(/([A-Z])/g, " $1").replace(/^./, (str) =>
                          str.toUpperCase()
                        )}
                    </h6>

                    <div style={{ fontSize: "0.875rem", fontWeight: "normal", marginTop: "8px" }}>
                      {sectionKey === "effectiveDate"
                        ? formatDate(sectionData)
                        : sectionKey === "exhibitsSchedules"
                          ? renderExhibitsSchedules(sectionData)
                          : hasSubCards(sectionData)
                            ? renderSubCards(sectionData, sectionKey)
                            : renderNestedObject(sectionData, 0, false)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Signatories */}
          {newData?.signatories && <div className="card border-0 shadow-sm mb-2 p-2" style={{ backgroundColor: "white" }}>
            <h6
              className="mb-2"
              style={{
                color: "black",
                fontSize: "0.95rem",
                fontWeight: "600", // semi-bold
                paddingBottom: "0.25rem",
                borderBottom: "1px solid #e9ecef",
              }}
            >
              Signatories
            </h6>

            <div style={{ fontSize: "0.875rem", fontWeight: "normal" }}>{renderSignatories(newData?.signatories)}</div>
          </div>}

        </div>
      </>
    );
  };
  const checkDataToRefresh = (data = []) => {
    return data.some(item => item.status === "PROCESSING");
  };



  return (
    <span>
      {
        <DataTables
          onRef={(ref) => (dataTableRef.current = ref)}
          {...props}
          getTableFields={getTableFields}
          onDownloadPdf={downloadPdf}   // ✅ ADD THIS LINE
          formFields={getFormFields}
          addRequired={false}
          editRequired={false}
          deleteRequired={true}
          viewRequired={true}
          exportRequired={true}
          sample={false}
          printRequried={false}
          actionsTypes={false}
          settingsRequired={false}
          filterRequired={false}
          gridRequried={false}
          exportToCsv={true}
          dateSearchRequired={false}
          searchInDateRangeField={""}
          setData={setData}
          editSelectedRecord={editSelectedRecord}
          addSelectedRecord={addSelectedRecord}
          viewSelectedRecord={viewSelectedRecord}
          sampleFilePath={filePath.agreement}
          displayName="Contracts & Agreements"
          type="agreement"
          routeTo={apiCalls.agreement}
          displayViewOfForm="modal"
          sideFormLeftOrRight="right"
          apiResponseKey={apiCalls.agreement?.toLowerCase()}
          apiUrl={apiCalls.agreement}
          selectedId={params.id}
          displayActionsInTable={"actions"}
          filterClearRequired={true}
          hideActions={true}
          sampleFiles={sampleFiles}
          customUpload={true}
          viewModalTemplate={agreementViewModalTemplate}
          needTimer={true}
          checkDataToRefresh={checkDataToRefresh}
        />
      }

    </span>
  );
};

export default Contracts;
